import { render } from "./ChartCard.vue?vue&type=template&id=bf5b3070&scoped=true"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"

import "./ChartCard.vue?vue&type=style&index=0&id=bf5b3070&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf5b3070"]])

export default __exports__